<div class="actions-wrap" fxLayout="column" fxLayoutAlign="center center">
  
  <div *ngIf="actionsLoaded && !actions.length">
    This connection has no actions
  </div>

  <div class="search-bar">
    <div fxLayoutAlign="start center">
      <div class="item-title" fxFlex="15" fxLayoutAlign="start center">Actions</div>
      <mat-form-field *ngIf="actions.length > 10" fxFlex="85" appearance="outline" style="margin-bottom: -1.25em;">
        <mat-label>Search for actions</mat-label>
        <input matInput (input)="searchActions($event)">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <spinner *ngIf="spinner" selfSpin="true"></spinner>  

  <div style="height: 1rem;"></div>

  <div 
    class="action-items-wrap"
    fxLayout="row wrap" fxLayoutAlign="start center" 
    style="text-align: center;"
    *ngIf="actions.length"
  >
    <!-- <mat-chip-set>
      <mat-chip 
        class="chip-item" 
        *ngFor="let action of filteredActions; trackBy: trackByFn" 
        [matTooltip]="'Execute ' + action.name"
        (click)="executeAction(action)"
      >
        <div fxLayout="row">
          <span class="button-text">{{ action.name }}</span>
          <mat-icon>chevron_right</mat-icon>
        </div>
      </mat-chip>
    </mat-chip-set> -->

    <app-list-panel 
      *ngIf="filteredActions.length"
      [panelMeta]="listPanelMeta" 
      [inputData]="filteredActions" 
      [builderMode]="false"
      (rowData)="executeAction($event)"
    ></app-list-panel>
  </div>


  <div style="height: 1rem;"></div>
  <mat-accordion *ngIf="actionResults.length" class="accordion example-headers-align">
    <mat-expansion-panel
      *ngFor="let actionresult of actionResults; let i = index; trackBy: trackByFn" 
      [expanded]="actionresult.isExpanded"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>{{ actionresult.action.name + " result" }}</mat-panel-title>
        <mat-panel-description>
          <mat-icon matTooltip="Discard result" (click)="deleteResult(i)">delete</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div class="action-result-list-wrap">
        <app-list-panel 
          [inputData]="actionresult.result" 
          [builderMode]="false"
          [isDynamicWidth]="true"
          [panelMeta]="{ listPanelTitle: actionresult.action.name + ' result' }"
        >
        </app-list-panel>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

</div>